import React from 'react';
import Input from './Input';

export default class PasswordInput extends React.Component {
    getValue() {
        return this.refs.input.state.value
    }

    validate() {
        return this.refs.input.validate((val)=> {
            return val.length >= 6 && /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s).{6,}$/.test(val);
        }, "Паролата Ви трябва да е минимум 6 символа и да съдържа поне една главна буква и цифра");
    }

    render() {
        return <Input ref="input" {...this.props} type="password" />
    }
}



// WEBPACK FOOTER //
// ./src/components/Presentation/Forms/PasswordInput.js